
// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import initializeOneSignal from './oneSignalConfig';

// Initialize OneSignal
const initApp = async () => {
  try {
    console.log('Starting OneSignal initialization...');
    await initializeOneSignal();
    console.log('OneSignal initialization completed');
  } catch (error) {
    console.error('Failed to initialize OneSignal:', error);
  }
};

// Create root and render app
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// Initialize OneSignal after app has mounted
initApp();
// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import { BrowserRouter } from 'react-router-dom';
// // import initializeGTM from './gtm';
// import initializeOneSignal from './oneSignalConfig';
// // initializeGTM();
// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(

//     <BrowserRouter>
//       <App />
//     </BrowserRouter>

// );

// initializeOneSignal()

// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );